import { createStore } from '@shared/utils/state/state-factory'

interface GenericFormStore {
  formValues: Record<string, Record<string, unknown>>
  setDefaultValues: (key: string, values: Record<string, unknown>) => void
  partialSet: (key: string, values: Record<string, unknown>) => void
  clear: (key: string) => void
  reset: () => void
  clearAllSimilarKeys: (key: string) => void
}

export const useGenericFormStore = createStore<GenericFormStore>(
  'generic-form',
  (set) => ({
    formValues: {},
    setDefaultValues: (key, values) =>
      set((state) => {
        state.formValues[key] = values
      }),
    partialSet: (key, values) =>
      set((state) => {
        state.formValues[key] = { ...state.formValues[key], ...values }
      }),
    reset: () => set({ formValues: {} }),
    clearAllSimilarKeys: (key: string) =>
      set((state) => {
        Object.keys(state.formValues).forEach((k) => {
          if (k.includes(key)) delete state.formValues[k]
        })
      }),
    clear: (key: string) =>
      set((state) => {
        delete state.formValues[key]
      }),
  }),
  { persist: true, shared: true },
)
